module.exports = __webpack_public_path__ + "img/achievement_25.35f05548.png";